var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('inner-table',{ref:"familyMembersList",attrs:{"id":"innerTableMembers","listviewurl":'teacher.familyMembers.list',"can-edit":1,"can-delete":1,"link-prop-name":''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }